import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Button, Row, Col } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import moment from 'moment';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import keyIn from 'shared/lib/immutable/keyIn';
import TimePicker from 'shared/components/pickers/timePicker.jsx';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';

/**
 * Preset Duration Picker Modal component
 *
 */
export default React.createClass({
  mixins: [
    PureRenderMixin,
    Reflux.connectFilter(CuesheetStore, 'rowState', (state) => {
      let rowState = ModalHelper.itemConnectFilter(
        (row) =>
          row.getIn(['editing', 'type']) === EditableCellTypes.ItemStartTime,
      )(state);

      if (!rowState) return rowState;

      rowState.startTimeValue = StartTimeMixin._getStartTimeValue(
        rowState.item,
        rowState.rowIndex,
        state.getIn(['show', 'startOn']),
      );

      return rowState;
    }),
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock', 'timeZone')),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'modalFields', (st) =>
      st.getIn(['modal', 'fields']),
    ),
  ],

  displayName: 'ItemStartTimeModal',

  render() {
    return (
      <Modal
        className="csr-modal-item-timer-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Start Time"
      >
        <div className="csr-modal-item-timer-content">
          {this._getTimePickerNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getTimePickerNode() {
    const { rowState, event } = this.state;

    if (!rowState) return null;

    return (
      <div className="text-center">
        <TimePicker.StandAlone
          showSeconds
          mobile
          twentyFour={event.get('twentyFourHourClock')}
          value={this._getTimeValue(true)}
          onChange={this._handleTimeChange}
        />
        {this._getResetButtonNode()}
      </div>
    );
  },

  _getResetButtonNode() {
    if (!this.state.rowState.item.get('startOn')) return null;

    return (
      <Row>
        <Col xs={24}>
          <Icon size={2} onClick={this._handleReset} name="undo" />
        </Col>
      </Row>
    );
  },

  _handleDone() {
    let startOn = this._getTimeValue();

    let changes = {
      startOn,
    };

    CuesheetCellActions.saveItemTimeFields(this._getRowIndex(), changes);

    CuesheetResponsiveActions.clearModalFields();
    ModalActions.hide(this._getModalId());
  },

  _handleTimeChange(time) {
    CuesheetResponsiveActions.updateModalField('startOn', time);
  },

  _handleReset() {
    const changes = {
      startOn: 0,
    };
    CuesheetCellActions.saveItemTimeFields(this._getRowIndex(), changes);
    CuesheetResponsiveActions.clearModalFields();
    ModalActions.hide(this._getModalId());
  },

  _getRowIndex() {
    return this.state.rowState.rowIndex;
  },

  _getTimeValue(forDisplay) {
    let { modalFields } = this.state;

    if (modalFields && typeof modalFields.get('startOn') === 'number') {
      if (!forDisplay) return modalFields.get('startOn');
      return (
        modalFields.get('startOn') ||
        moment().hours(0).minutes(0).seconds(0).valueOf()
      );
    }

    return this.state.rowState.startTimeValue;
  },

  _getItem() {
    return this.state.rowState.item;
  },

  _getModalId() {
    return UIRegions.CuesheetItemStartTime;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
